<template>
  <div class="AddSchedule lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddSchedule-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddSchedule-main lxn-pos-rel">
      <div class="AddSchedule-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddSchedule_title1}}
          </template>
          <template v-slot:body>
            <div class="AddSchedule-wrapper-colors lxn-w100">
              <div @click="activeBoxIndex = 0;" class="AddSchedule-color color1 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(0)" :class="isBoxActive(0)">
                <div class="AddSchedule-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 1;" class="AddSchedule-color color2 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(1)" :class="isBoxActive(1)">
                <div class="AddSchedule-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 2;" class="AddSchedule-color color3 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(2)" :class="isBoxActive(2)">
                <div class="AddSchedule-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 3;" class="AddSchedule-color color4 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(3)" :class="isBoxActive(3)">
                <div class="AddSchedule-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 4;" class="AddSchedule-color color5 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(4)" :class="isBoxActive(4)">
                <div class="AddSchedule-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
            </div>
            <div class="AddSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSchedule_text1}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" v-model="ScheduleName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.AddSchedule_namePlaceHolder" inputType="text" />
            </div>
            <div class="AddSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSchedule_text2}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetHub" :dropDownContex="dropDownTargetHub" />
            </div>
            <div class="AddSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSchedule_text7}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetScheduleType" :dropDownContex="dropDownTargetScheduleType" />
            </div>
          </template>
        </TitleBox>
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddSchedule_title2}}
          </template>
          <template v-slot:body>
          <div v-if="targetScheduleType == 2" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]" class="AddSchedule-wrapper-name-text lxn-w100 lxn-text">
            {{$store.getters.language.texts.AddSchedule_title4}}
          </div>  
          <div :class="$store.getters.language.directionClass" style="display:flex;flex-wrap: nowrap; justify-content: space-between; gap:10px">
            <div style="flex-grow: 1;">
              <div class="AddSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                {{$store.getters.language.texts.AddSchedule_text3}}
              </div>
              <div class="lxn-w100 lxn-overflow-hidden">
                <NumberInputSpinner :min="0" :max="23" :step="1" :integerOnly="true" v-model="hour" buttonClass="AddSchedule-commandDelay-button" :twoDigitsOnly="true" />
              </div>
            </div>
            <div style="flex-grow: 1;">
              <div class="AddSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                {{$store.getters.language.texts.AddSchedule_text4}}
              </div>
              <div class="lxn-w100 lxn-overflow-hidden">
                <NumberInputSpinner :min="0" :max="59" :step="1" :integerOnly="true" v-model="minute" buttonClass="AddSchedule-commandDelay-button" :twoDigitsOnly="true" />
              </div>
            </div>
          </div>
          <div v-if="targetScheduleType == 2" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]" class="AddSchedule-wrapper-name-text lxn-w100 lxn-text">
            {{$store.getters.language.texts.AddSchedule_title5}}
          </div>
          <div v-if="targetScheduleType == 2" :class="$store.getters.language.directionClass" style="display:flex;flex-wrap: nowrap; justify-content: space-between; gap:10px">
            <div style="flex-grow: 1;">
              <div class="AddSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                {{$store.getters.language.texts.AddSchedule_text3}}
              </div>
              <div class="lxn-w100 lxn-overflow-hidden">
                <NumberInputSpinner :min="0" :max="23" :step="1" :integerOnly="true" v-model="endHour" buttonClass="AddSchedule-commandDelay-button" :twoDigitsOnly="true" />
              </div>
            </div>
            <div style="flex-grow: 1;">
              <div class="AddSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                {{$store.getters.language.texts.AddSchedule_text4}}
              </div>
              <div class="lxn-w100 lxn-overflow-hidden">
                <NumberInputSpinner :min="0" :max="59" :step="1" :integerOnly="true" v-model="endMinute" buttonClass="AddSchedule-commandDelay-button" :twoDigitsOnly="true" />
              </div>
            </div>
          </div>  
            <div class="AddSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSchedule_text5}}
            </div>
            <div class="lxn-w100 lxn-overflow-hidden">
              <div @click="daySelected(6)" class="AddSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(6), $store.getters.language.font, $store.getters.language.directionClass]">
                {{$store.getters.language.texts.weekDaysShort[6]}}
              </div>
              <div @click="daySelected(0)" class="AddSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(0), $store.getters.language.font, $store.getters.language.directionClass]">
                {{$store.getters.language.texts.weekDaysShort[0]}}
              </div>
              <div @click="daySelected(1)" class="AddSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(1), $store.getters.language.font, $store.getters.language.directionClass]">
                {{$store.getters.language.texts.weekDaysShort[1]}}
              </div>
              <div @click="daySelected(2)" class="AddSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(2), $store.getters.language.font, $store.getters.language.directionClass]">
                {{$store.getters.language.texts.weekDaysShort[2]}}
              </div>
              <div @click="daySelected(3)" class="AddSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(3), $store.getters.language.font, $store.getters.language.directionClass]">
                {{$store.getters.language.texts.weekDaysShort[3]}}
              </div>
              <div @click="daySelected(4)" class="AddSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(4), $store.getters.language.font, $store.getters.language.directionClass]">
                {{$store.getters.language.texts.weekDaysShort[4]}}
              </div>
              <div @click="daySelected(5)" class="AddSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(5), $store.getters.language.font, $store.getters.language.directionClass]">
                {{$store.getters.language.texts.weekDaysShort[5]}}
              </div>
            </div>
          </template>
        </TitleBox>
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddSchedule_title3}}
          </template>
          <template v-slot:body>
            <CommandCreator v-model="generatedCommand" titleBgColor="#00AEEF" :multiHub="false" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" :showAutomations="targetScheduleType == 1" :showInputs="targetScheduleType == 2" />
          </template>
        </TitleBox>
      </div>
      <div class="AddSchedule-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.AddSchedule_button}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CommandCreator from '@/components/CommandCreator.vue'
import CustomButton from '@/components/CustomButton.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import CustomInput from '@/components/CustomInput.vue'
import DropDown from '@/components/DropDown.vue'
import NumberInputSpinner from '@/components/NumberInputSpinner.vue'
import TitleBox from '@/components/TitleBox.vue'
import TopNav from '@/components/TopNav.vue'
import * as CONFIGS from '@/statics/configs.js'
import NODE7 from '@/statics/devices/Node7/header.js'
import Logger from '@/statics/logger.js'
import Messaging from '@/statics/messaging.js'
import Vue from 'vue'

var messaging = new Messaging(new Logger(false));

export default {
  name: 'AddSchedule',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    DropDown,
    NumberInputSpinner,
    CommandCreator
  },
  data: function () {
    return {
      hour: new Date().getHours(),
      minute: new Date().getMinutes(),
      endHour: new Date().getHours(),
      endMinute: new Date().getMinutes(),
      ScheduleName: '',
      input1State: '',
      activeBoxIndex: 0,
      targetHub: 0,
      targetScheduleType: 0,
      repeatDays: [false, false, false, false, false, false, false],
      generatedCommand: [],
    }
  },
  mounted: function () {
  },
  watch: {
    targetScheduleType: function (newVal) {
      console.log("targetScheduleType", newVal);   
    }
  },
  computed: {
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    dropDownTargetHub: function () {
      var dropDownTargetHub = {
        name: "AddSchedules-TargetHubs",
        title: this.$store.getters.language.texts.AddSchedule_text2,
        selectedIndex: this.targetHub,
        data: []
      };
      for(var i = 0; i < this.$store.state.hubs.length; i++){
        dropDownTargetHub.data.push({
          name: this.$store.state.hubs[i].name,
          icon: "hub",
        })
      }
      return dropDownTargetHub;
    },
    dropDownTargetScheduleType: function () {
      var dropDownTargetScheduleType = {
        name: "AddSchedules-TargetScheduleType",
        title: this.$store.getters.language.texts.AddSchedule_text7,
        selectedIndex: this.targetScheduleType,
        data: [
          {
            name: this.$store.getters.language.texts.AddSchedule_text8,
            icon: "lamp",
          },
          {
            name: this.$store.getters.language.texts.AddSchedule_text9,
            icon: "auto",
          },
          {
            name: this.$store.getters.language.texts.AddSchedule_text10,
            icon: "notifs",
          }
        ]
      };
      return dropDownTargetScheduleType;
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    isBoxActive: function (boxIndex) {
      if(this.activeBoxIndex == boxIndex) {
        return 'active';
      }else{
        return '';
      }
    },
    repeatDaysSelected: function (index) {
      if(this.repeatDays[index] == true){
        return 'active';
      }else{
        return '';
      }
    },
    daySelected: function (index) {
      var newVal = !this.repeatDays[index];
      Vue.set(this.repeatDays, index, newVal);
    },
    generateNodeActions: function (nodeActions) {
      var generatedNodeActions = [];
      var typeOfAction = 0;
      var valueOfChange = 0;

      for(var i = 0; i < nodeActions.length; i++){
        var isNodeNew = true;
        if(nodeActions[i].outputType != "IrDevice"){
          if(nodeActions[i].state == 'on'){
            typeOfAction = CONFIGS.ACTION_TYPE_SET;
            valueOfChange = 1;
          }else if(nodeActions[i].state == 'off'){
            typeOfAction = CONFIGS.ACTION_TYPE_SET;
            valueOfChange = 0;
          }
        }else{
          var deviceType = nodeActions[i].outputSettings.deviceType;
          var brand = nodeActions[i].outputSettings.brand;
          var model = nodeActions[i].outputSettings.model;
          var irDevice = NODE7.devices[deviceType].brands[brand].devices[model];

          valueOfChange = messaging.utility.arrayTo128(irDevice.commands[nodeActions[i].state.targetCommandIndex].command);
          typeOfAction = CONFIGS.ACTION_TYPE_SET;
        }
        var action = {
          parameterId: nodeActions[i].parameterId,
          valueOfChange: valueOfChange,
          typeOfAction: typeOfAction,
          timeDelay: nodeActions[i].timeDelay,
        }

        for(var j = 0; j < generatedNodeActions.length; j++){
          if(generatedNodeActions[j].nodeUUID == nodeActions[i].nodeUUID){
            generatedNodeActions[j].actions.push(action);
            isNodeNew = false;
            break;
          }
        }
        if(isNodeNew){
          generatedNodeActions.push(
            {
              nodeUUID: nodeActions[i].nodeUUID,
              actions: [action]
            }
          );
        }
      }
      return generatedNodeActions;
    },
    calculateDateTimeStamp: function (hour, minute) {
        var currentEpochTime = Date.now();

        var targetDateStamp = Math.floor(currentEpochTime / 86400000);
        var targetTimeStamp = 0;

        var localDateObject = new Date();
        var repeatMask = 0;

        var anyDaysSelected = false;
        console.log("targetDateStamp: ", targetDateStamp);
        for(var i = 0; i < this.repeatDays.length; i++){
          if(this.repeatDays[i] == true){
            anyDaysSelected = true;
          }
        }
        
        if(!anyDaysSelected){
          console.log("!anyDaysSelected")
          var userSelectedLocalTimeStamp = (hour*60 + minute) * 60000;
          console.log("userSelectedLocalTimeStamp", userSelectedLocalTimeStamp);
          var currentLocalTimeStamp = ((localDateObject.getHours()*60 + localDateObject.getMinutes()) * 60 + localDateObject.getSeconds()) * 1000;
          var timeStampDiff = userSelectedLocalTimeStamp - currentLocalTimeStamp;
          console.log("currentLocalTimeStamp", currentLocalTimeStamp);
          console.log("timeStampDiff", timeStampDiff);
          if(timeStampDiff < 0){
            timeStampDiff += 86400000;
          }
          var userSelectedDateTimeStamp = currentEpochTime + timeStampDiff;
          console.log("userSelectedDateTimeStamp", userSelectedDateTimeStamp);
          targetDateStamp = Math.floor(userSelectedDateTimeStamp / 86400000);
          console.log("targetDateStamp", targetDateStamp);
          targetTimeStamp = userSelectedDateTimeStamp % 86400000;
          console.log("targetTimeStamp", targetTimeStamp);
          repeatMask = CONFIGS.SCHEDULE_REPEAT_MASK_OCCATIONAL;
          // console.log()
        }else{
          console.log("anyDaysSelected")
          var weekDaysOffset = 0;
          var timeZoneOffset = localDateObject.getTimezoneOffset();

          var timeStampInMinutes = hour*60 + minute + timeZoneOffset;

          if(timeStampInMinutes < 0){
            timeStampInMinutes += 24*60;
            weekDaysOffset = -1;
          }else if(timeStampInMinutes >= 24*60){
            timeStampInMinutes -= 24*60;
            weekDaysOffset = 1;
          }
          targetTimeStamp = timeStampInMinutes*60000;

          for(i = 0; i < this.repeatDays.length; i++){
            if(this.repeatDays[i] == true){
              //unsigned mod implementation in js:
              var weekDayWithOffset = (((i + weekDaysOffset) % 7) + 7) % 7;
              console.log("weekDayWithOffset", weekDayWithOffset);
              repeatMask |= CONFIGS.SCHEDULE_REPEAT_MASK_WEEKDAYS[weekDayWithOffset];
            }
          }
        }
        return {
          repeatMask:repeatMask,
          resultDateStamp: targetDateStamp,
          resultTimeStamp: targetTimeStamp 
        }
    },
    saveChanges: async function () {
      this.input1State = '';
      if(this.ScheduleName == ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.AddSchedule_alert1);
      }else if(this.generatedCommand.length == 0){
        alert(this.$store.getters.language.texts.AddSchedule_alert5);
      }else{
        var hub = this.$store.state.hubs[this.targetHub];
        var messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: hub.psk,
          destinationUUID: hub.uuid,
          sourceUUID: this.$store.state.user.uuid
        });
        console.log("this.hour, this.minute, this.endHour, this.endMinute",this.hour, this.minute, this.endHour, this.endMinute);
        let { repeatMask, resultDateStamp, resultTimeStamp} = this.calculateDateTimeStamp(this.hour, this.minute);
        // let reversedMaskslist = JSON.parse(JSON.stringify(this.generatedCommand[0].maskList));
        let targetDateStamp = resultDateStamp;
        let targetTimeStamp = resultTimeStamp;
        ({repeatMask, resultDateStamp, resultTimeStamp} = this.calculateDateTimeStamp(this.endHour, this.endMinute));   
        let endTargetDateStamp = resultDateStamp;
        let endTargetTimeStamp = resultTimeStamp;
        console.log("repeatMask", repeatMask);
        console.log("targetDateStamp", targetDateStamp, endTargetDateStamp , this.endHour, this.endMinute);
        console.log("targetargetTimeStamp", targetTimeStamp, endTargetTimeStamp );
        this.$store.commit('setAppBusy', true);

        // this.$store.commit('setAppBusy', false);
        // console.log(repeatMask.raiseanerror.ok);
        try {
          var instructionList = await this.$store.dispatch('readHubInstructions', {messagingHook: messagingHook,hubUUID: hub.uuid});
          instructionList = instructionList.body.bodyContent.instructionList;
          console.log("instructionlist1 ", instructionList);
          var imitatorsList = await this.$store.dispatch('getUplinkImitators', {messagingHook: messagingHook,hubUUID: hub.uuid});
          console.log("instructionlist2")
          imitatorsList = imitatorsList.body.bodyContent.imitatorsList;
          console.log("imitatorsList: ", imitatorsList);
          var newScheduleId = 0;
          console.log("before instructions");
          for(let i = 1; i < 255; i++){
            console.log("check instructions");
            var foundInstruction = instructionList.find(instruction => {
              if(instruction.eventIdToWatch >> 8 == CONFIGS.SCHEDULE_EVENT_ID_PREFIX){
                var scheduleId = instruction.eventIdToWatch & 0xFF;
                return scheduleId == i;
              }
              return false;
            });
            if(!foundInstruction){
              foundInstruction = imitatorsList.find(imitator => {
                if(imitator.eventIdToWatch >> 8 == CONFIGS.SCHEDULE_EVENT_ID_PREFIX){
                  var scheduleId = imitator.eventIdToWatch & 0xFF;
                  console.log("imitator fuond with scheduleid", scheduleId);
                  return scheduleId == i;
                }
                console.log("imitator fuond with not found!");
                return false;
              });
            }
            if(!foundInstruction){
              newScheduleId = i;
              break;
            }
          }
          console.log("instructionList", instructionList, newScheduleId);
          // if (instructionList != undefined) {
          //   throw "wait wait! let me tell you something!";
          // }
          if(newScheduleId == 0){
            alert(this.$store.getters.language.texts.AddSchedule_alert6);
            this.$store.commit('setAppBusy', false);
            return;
          }
          var newEventIdToWatch = (CONFIGS.SCHEDULE_EVENT_ID_PREFIX << 8) + newScheduleId;
          instructionList = [];
          console.log("newScheduleId: ", newScheduleId);
          var scheduleCommand = [];
          var secondScheduleCommand = []; // in case of this.targetScheduleType == 2 the second schedule command will be used to reverse the first maskslist 
          if(this.targetScheduleType == 1 ||  this.targetScheduleType == 2){
            scheduleCommand = messagingHook.createHubMessage(
              {
                messageType: messagingHook.UPLINK_PACKET_SET_EVENT_MASKS,
                bodyContent: {
                  maskList: this.generatedCommand[0].maskList
                },
              }
            ).serializedMessageArray.splice(19);
            if (this.targetScheduleType == 2) {
              console.log("scheduleCommand: ", scheduleCommand);
              let reversedMaskslist = JSON.parse(JSON.stringify(this.generatedCommand[0].maskList));
              reversedMaskslist = reversedMaskslist.map(mask => {
                mask.isMasked = !mask.isMasked;
                return mask
              })
              console.log("reversed mask list", reversedMaskslist);
              console.log("mask list", this.generatedCommand[0].maskList);

              secondScheduleCommand = messagingHook.createHubMessage(
                {
                  messageType: messagingHook.UPLINK_PACKET_SET_EVENT_MASKS,
                  bodyContent: {
                    maskList: reversedMaskslist
                  },
                }
              ).serializedMessageArray.splice(19);
            }
          }else{
            var nodeActions = this.generateNodeActions(this.generatedCommand[0].actions);
            messagingHook.setParametersOfNodesSerializer(scheduleCommand, {nodeActions: nodeActions});
            console.log("nodeAction: ", nodeActions);
          }
          
          if(this.targetScheduleType == 1 || this.targetScheduleType == 2){
            imitatorsList.push({
              eventIdToWatch: newEventIdToWatch,
              commandLength: scheduleCommand.length,
              commandToSend: scheduleCommand,
            })
            if(this.targetScheduleType == 2){
                imitatorsList.push({
                eventIdToWatch: (CONFIGS.SCHEDULE_EVENT_ID_PREFIX << 8) + newScheduleId + 1,
                commandLength: secondScheduleCommand.length,
                commandToSend: secondScheduleCommand,
              })
            }
            console.log('imitatorsList: ', imitatorsList);
            await this.$store.dispatch('setUplinkImitator', {
              messagingHook: messagingHook,
              hubUUID: hub.uuid,
              imitatorsList: imitatorsList,
            })
          }else{
            instructionList.push({
              eventIdToWatch: newEventIdToWatch,
              commandLength: scheduleCommand.length,
              commandToSend: scheduleCommand,
            });

            await this.$store.dispatch('modifyHubInstructions', {
              messagingHook: messagingHook,
              hubUUID: hub.uuid,
              instructions: instructionList,
            })
          }
          var schedulesList = await this.$store.dispatch('readHubSchedules', {messagingHook: messagingHook,hubUUID: hub.uuid});
          schedulesList = schedulesList.body.bodyContent.schedulesList;
          var schedule = {
            timeEvent: {
              dateStamp: targetDateStamp,
              timeStamp: targetTimeStamp,
              repeatMask: repeatMask,
            },
            eventId: newEventIdToWatch,
          };
          schedulesList.push(schedule);
          if(this.targetScheduleType == 2){
            var secondSchedule = {
              timeEvent: {
                dateStamp: endTargetDateStamp, 
                timeStamp: endTargetTimeStamp,
                repeatMask: repeatMask,
              },
              eventId: (CONFIGS.SCHEDULE_EVENT_ID_PREFIX << 8) + newScheduleId + 1,
            };
            schedulesList.push(secondSchedule); 
          }
          console.log('schedulesList => ', schedulesList)
          await this.$store.dispatch('setHubSchedules', {
            messagingHook: messagingHook,
            hubUUID: hub.uuid,
            bodyContent: {
              schedulesList: schedulesList,
            }
          })
          this.$store.commit('addSchedule', {
              name: this.ScheduleName,
              color: this.activeBoxIndex,
              hubUUID: hub.uuid,
              eventIdToWatch: newEventIdToWatch,
              timeEvent: {
                dateStamp: targetDateStamp,
                timeStamp: targetTimeStamp,
                repeatMask: repeatMask,
              },
              scheduleCommand: scheduleCommand,
              active: true,
              type: this.targetScheduleType,
              hasSecondary: this.targetScheduleType == 2 ? true : false,
              commandMaskList: this.generatedCommand[0].maskList 
          });
          if(this.targetScheduleType == 2){
            this.$store.commit('addSchedule', {
              name: `${this.ScheduleName } - reverse`,
              color: this.activeBoxIndex,
              hubUUID: hub.uuid,
              eventIdToWatch: newEventIdToWatch+1,
              timeEvent: {
                dateStamp: endTargetDateStamp,
                timeStamp: endTargetTimeStamp,
                repeatMask: repeatMask,
              },
              scheduleCommand: secondScheduleCommand,
              active: true,
              type: this.targetScheduleType,
              hasSecondary: false,             
          });
          }

          this.$store.commit('saveState');
          // this.$router.push('/schedules');
          this.$store.commit('setAppBusy', false)
        }
        catch (response) {
          console.log("error",response);
          if(response.rejectCode == 2){
            this.$router.push('/SettingsHubError');
            this.$store.commit('setHubStatus', {
              hubIndex: response.hubIndex,
              connectionStatus: {
                local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              },
            });
          }else{
            this.$router.push('/SettingsHubError');
          }
          this.$store.commit('setAppBusy', false);
        }
      }
    },
  }
}
</script>

<style>
  .AddSchedule-topCurve-wrapper {
    height: 200px;
  }
  .AddSchedule-main {
    z-index: 2;
  }
  .AddSchedule-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .AddSchedule-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .AddSchedule-wrapper-colors {
    height: 50px;
  }
  .AddSchedule-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .AddSchedule-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .AddSchedule-color.active .AddSchedule-selectedColor {
    opacity: 1;
  }
  .AddSchedule-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .AddSchedule-wrapper-name-text {
    height: 50px;
    padding-top: 20px;
    line-height: 30px;
    color: #52626C;
  }
  .AddSchedule-wrapper-name-text:first-child {
    height: 30px;
    padding-top: 0;
  }
  .AddSchedule-wrapper-fieldTitles {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .AddSchedule-commandDelay-button {
    -webkit-appearance: none;
    transition: opacity 0.5s ease;
    background: #1EA5DE;
    border: 0;
    border-radius: 7px;
    overflow: hidden;
    color: #fff;
    cursor: pointer;
    float: left;
    font-size: 20px;
    height: 40px;
    margin: 0;
    width: 40px;
  }
  .AddSchedule-commandDelay-button:hover {
    opacity: 0.5;
  }
  .AddSchedule-commandDelay-button:hover {
    opacity: 0.5;
  }
  .AddSchedule-commandDelay-button:focus {
      outline: 0;
      outline-offset: 0;
  }
  .AddSchedule-todayOnly {
    display: table;
    padding-left: 20px;
    padding-right: 20px;
    line-height: 40px;
    line-height: 40px;
    background-color: #53636C;
    color: #FFFFFF;
  }
  .AddSchedule-todayOnly.active {
    background-color: #1EA5DE;
  }
  .AddSchedule-days {
    width: calc(100% / 7 - 4px);
    height: 40px;
    margin-right: 2px;
    margin-left: 2px;
    line-height: 40px;
    background-color: #53636C;
    color: #FFFFFF;
  }
  .AddSchedule-days.active {
    background-color: #1EA5DE;
  }
</style>
